export function isApex(domainName: string) {
  return domainName.split('.').length == 2;
}
